/* ============================================================
   BioActive+ Home V2 — shared front-end behaviour for Dawn
   Loaded once (guarded). Powers:
     · scroll reveals + absorption bars
     · marquees (ticker / press)
     · FAQ accordion
     · product explorer (Discover)
     · bundle builder (discount ladder + add stack)
     · ?preload= dispatcher → fills the bundle-page builder via bb:add
     · sticky add-to-cart bar (mini-cart, vial stack, dynamic
       discount strip, Subscribe + 30/60-day frequency pills)
     · 60-second quiz modal
     · Dawn-aware add-to-cart + toast
   Re-inits in the Theme Editor via shopify:section:load.
   ============================================================ */
(function () {
  if (window.__baHome) return;
  window.__baHome = true;

  var PALETTE = ['#9c4456', '#7cc0b6', '#e2c463', '#d75a4a', '#d573a8', '#d0894a'];

  /* ---------- money ---------- */
  function money(cents, symbol) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      try { return Shopify.formatMoney(cents, window.Shopify.money_format); } catch (e) {}
    }
    var n = (cents || 0) / 100;
    var s = (Math.round(n) === n) ? String(n) : n.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (symbol ? symbol + ' ' : '') + s;
  }

  /* ---------- scroll reveal + bars ---------- */
  function fillBars(el) {
    el.querySelectorAll('.barh-fill[data-val]').forEach(function (b) {
      b.style.width = b.getAttribute('data-val') + '%';
    });
  }
  function initReveals(root) {
    var els = (root || document).querySelectorAll('[data-ba-reveal]:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); fillBars(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); fillBars(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- marquee ---------- */
  function initMarquees(root) {
    (root || document).querySelectorAll('[data-ba-marquee]:not([data-ba-cloned])').forEach(function (track) {
      track.setAttribute('data-ba-cloned', '1');
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-ba-faq]:not([data-ba-bound])').forEach(function (grid) {
      grid.setAttribute('data-ba-bound', '1');
      grid.addEventListener('click', function (e) {
        var q = e.target.closest('.faq-q'); if (!q) return;
        var item = q.closest('.faq-item');
        var open = item.classList.contains('open');
        grid.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); i.querySelector('.faq-q').setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('open'); q.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------- Discover explorer ---------- */
  function initDiscover(root) {
    (root || document).querySelectorAll('[data-ba-discover]:not([data-ba-bound])').forEach(function (grid) {
      grid.setAttribute('data-ba-bound', '1');
      grid.addEventListener('click', function (e) {
        if (e.target.closest('[data-ba-add]')) return; // add handled globally
        var chip = e.target.closest('.disc-chip'); if (!chip) return;
        grid.querySelectorAll('.disc-chip').forEach(function (c) { c.classList.remove('on'); c.setAttribute('aria-selected', 'false'); });
        chip.classList.add('on'); chip.setAttribute('aria-selected', 'true');
        var target = chip.getAttribute('data-target');
        grid.querySelectorAll('.disc-detail').forEach(function (d) {
          var match = d.id === 'disc-' + target;
          d.hidden = !match;
          if (match) { d.classList.remove('swap'); void d.offsetWidth; d.classList.add('swap'); }
        });
      });
    });
  }

  /* ---------- Bundle builder (home-page variant) ---------- */
  function initBuilder(root) {
    (root || document).querySelectorAll('[data-ba-builder]:not([data-ba-bound])').forEach(function (card) {
      card.setAttribute('data-ba-bound', '1');
      var max = parseInt(card.getAttribute('data-max') || '4', 10);
      var t2 = parseFloat(card.getAttribute('data-tier2') || '10') / 100;
      var t4 = parseFloat(card.getAttribute('data-tier4') || '20') / 100;
      var freeShip = parseFloat(card.getAttribute('data-free-ship') || '0');
      var symbol = card.getAttribute('data-symbol') || '';
      var slotsEl = card.querySelector('.slots');
      var ladderFill = card.querySelector('.ladder-fill');
      var ladderHint = card.querySelector('.ladder-hint');
      var ladderMs = card.querySelector('.ladder-ms');
      var sumBody = card.querySelector('.sum-body');
      var addBtn = card.querySelector('.sum-add');
      var picks = [];

      /* generate milestone dots once */
      var CHECK_SVG = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M20 6 9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (ladderMs && max > 1) {
        var msHTML = '';
        for (var mi = 1; mi <= max; mi++) {
          var leftPct = ((mi - 1) / (max - 1)) * 100;
          var mRate = mi === 1 ? 0 : mi === max ? t4 : t2 + (t4 - t2) * (mi - 1) / (max - 1);
          var mLbl = mi === 1 ? 'Pick' : Math.round(mRate * 100) + '%';
          msHTML += '<div class="milestone" data-ms-n="' + mi + '" style="left:' + leftPct + '%">' +
            '<div class="ms-label">' + mLbl + '</div>' +
            '<div class="ms-dot">' + CHECK_SVG + '</div></div>';
        }
        ladderMs.innerHTML = msHTML;
      }

      function tierRate(n) { return n >= 4 ? t4 : n >= 2 ? t2 : 0; }
      function render() {
        var n = picks.length;
        slotsEl.innerHTML = '';
        for (var i = 0; i < max; i++) {
          var p = picks[i];
          var slot = document.createElement('div');
          if (p) {
            slot.className = 'slot slot-filled pop';
            slot.style.background = 'radial-gradient(circle at 50% 38%, ' + p.glow + '55, rgba(255,255,255,.03))';
            slot.innerHTML = (p.img ? '<span class="ba-photo" style="position:absolute;inset:0;background:url(' + p.img + ') center/cover;"></span>' : '<span class="sv" style="background:linear-gradient(155deg,' + p.glow + ',' + shade(p.glow) + ');"></span>') +
              '<span class="slot-name">' + esc(p.name) + '</span>' +
              '<button class="slot-x" data-i="' + i + '" aria-label="Remove"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
          } else {
            slot.className = 'slot slot-empty' + (i === n ? ' next' : '');
            slot.innerHTML = '<span class="plus"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 5v14M5 12h14"/></svg></span>';
          }
          slotsEl.appendChild(slot);
        }
        ladderFill.style.width = Math.min(100, (n / max) * 100) + '%';
        card.querySelectorAll('.milestone[data-ms-n]').forEach(function (ms) {
          ms.classList.toggle('hit', n >= parseInt(ms.getAttribute('data-ms-n'), 10));
        });
        card.querySelectorAll('.bp').forEach(function (bp) {
          var vid = bp.getAttribute('data-variant-id');
          var cnt = picks.filter(function (p) { return p.id === vid; }).length;
          var badge = bp.querySelector('.bp-ct');
          if (badge) { badge.textContent = cnt; badge.style.display = cnt > 0 ? '' : 'none'; }
        });
        var nextN = n < 2 ? 2 : n < 4 ? 4 : null;
        var nextPct = n < 2 ? Math.round(t2 * 100) : Math.round(t4 * 100);
        ladderHint.innerHTML = n === 0 ? 'Add a formula to start saving'
          : nextN ? 'Add <b>' + (nextN - n) + ' more</b> to unlock <b>' + nextPct + '% off</b>'
          : 'Max savings unlocked — <b>' + Math.round(t4 * 100) + '% off</b> 🎉';
        var subtotal = picks.reduce(function (s, p) { return s + p.price; }, 0);
        var rate = tierRate(n);
        var total = Math.round(subtotal * (1 - rate));
        var saved = subtotal - total;
        if (n === 0) {
          sumBody.innerHTML = '<div class="sum-empty">Your stack is empty.<br>Add formulas to see your savings.</div>';
        } else {
          var html = '<div class="sum-row"><span>' + n + ' ' + (n === 1 ? 'formula' : 'formulas') + '</span><span class="tnum">' + money(subtotal, symbol) + '</span></div>';
          if (rate > 0) html += '<div class="sum-row save"><span>Bundle discount (' + Math.round(rate * 100) + '%)</span><span class="tnum">−' + money(saved, symbol) + '</span></div>';
          html += '<div class="sum-row"><span>Delivery</span><span>' + (total >= freeShip ? 'FREE' : money(parseFloat(card.getAttribute('data-ship-fee') || '0'), symbol)) + '</span></div>';
          html += '<div class="sum-total"><span class="tl">Total</span><span class="tv tnum">' + money(total, symbol) + '</span></div>';
          sumBody.innerHTML = html;
        }
        addBtn.disabled = n === 0;
      }
      function shade(hex) { return hex; }
      card.addEventListener('click', function (e) {
        var bp = e.target.closest('.bp');
        var x = e.target.closest('.slot-x');
        if (x) { picks.splice(parseInt(x.getAttribute('data-i'), 10), 1); render(); return; }
        if (bp && picks.length < max) {
          picks.push({
            id: bp.getAttribute('data-variant-id'),
            name: bp.getAttribute('data-name'),
            price: parseInt(bp.getAttribute('data-price') || '0', 10),
            glow: bp.getAttribute('data-glow') || '#9c4456',
            img: bp.getAttribute('data-img') || ''
          });
          render();
        }
      });
      addBtn.addEventListener('click', function () {
        if (!picks.length) return;
        var counts = {};
        picks.forEach(function (p) { counts[p.id] = (counts[p.id] || 0) + 1; });
        var items = Object.keys(counts).map(function (id) { return { id: id, quantity: counts[id] }; });
        window.baAddToCart(items, { toastMessage: 'Bundle added to cart' });
        picks = []; render();
      });
      render();

      /* preload into the home-page builder too (?preload=vid,vid) */
      var pre = null;
      try { pre = new URLSearchParams(window.location.search).get('preload'); } catch (e) {}
      if (pre && !card.getAttribute('data-ba-preloaded')) {
        card.setAttribute('data-ba-preloaded', '1');
        pre.split(',').forEach(function (vid) {
          vid = vid.trim();
          if (!vid || vid === '0' || picks.length >= max) return;
          var bp = card.querySelector('.bp[data-variant-id="' + vid + '"]');
          if (bp) picks.push({
            id: vid,
            name: bp.getAttribute('data-name'),
            price: parseInt(bp.getAttribute('data-price') || '0', 10),
            glow: bp.getAttribute('data-glow') || '#9c4456',
            img: bp.getAttribute('data-img') || ''
          });
        });
        if (picks.length) render();
      }
    });
  }

  /* ---------- ?preload= → bundle-page builder (bb:add bus) ----------
     The Build-a-Bundle page's own section listens for document-level
     'bb:add' events ({detail:{id:<variantId>}}), adds the variant to a
     slot, renders, and scrolls the builder into view. We just dispatch. */
  function initBundlePreload() {
    if (window.__baPreloadFired) return;
    var isBundleHost = document.querySelector('[data-bb]');
    if (!isBundleHost) return;
    var pre = null;
    try { pre = new URLSearchParams(window.location.search).get('preload'); } catch (e) {}
    if (!pre) return;
    window.__baPreloadFired = true;
    var ids = pre.split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(function (n) { return n > 0; });
    if (!ids.length) return;
    setTimeout(function () {
      ids.forEach(function (id) {
        document.dispatchEvent(new CustomEvent('bb:add', { detail: { id: id } }));
      });
      if (window.baToast) window.baToast(ids.length > 1 ? 'Your protocol is loaded' : 'Your formula is loaded');
    }, 120);
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initStickyBars(root) {
    (root || document).querySelectorAll('[data-ba-stickybar]:not([data-ba-bound])').forEach(function (bar) {
      bar.setAttribute('data-ba-bound', '1');
      var trigger = parseInt(bar.getAttribute('data-trigger') || '760', 10);
      var t2 = parseFloat(bar.getAttribute('data-tier2') || '10');
      var t4 = parseFloat(bar.getAttribute('data-tier4') || '20');
      var symbol = bar.getAttribute('data-symbol') || '';
      var freeShip = parseFloat(bar.getAttribute('data-free-ship') || '0');
      var heroVariant = bar.getAttribute('data-hero-variant');
      var heroGlow = bar.getAttribute('data-hero-glow') || '#9c4456';
      var subBtn = bar.querySelector('[data-ba-sub]');
      var freqWrap = bar.querySelector('[data-ba-freq]');
      var subscribed = false, freq = 30;

      var onScroll = function () { bar.classList.toggle('show', window.scrollY > trigger); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

      if (subBtn) subBtn.addEventListener('click', function () {
        subscribed = !subscribed;
        subBtn.classList.toggle('on', subscribed);
        subBtn.setAttribute('aria-pressed', subscribed ? 'true' : 'false');
        subBtn.querySelector('.sb-sub-box').innerHTML = subscribed ? '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>' : '';
        if (freqWrap) freqWrap.hidden = !subscribed;
      });
      if (freqWrap) freqWrap.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-freq]'); if (!b) return;
        freq = parseInt(b.getAttribute('data-freq'), 10);
        freqWrap.querySelectorAll('button[data-freq]').forEach(function (x) { x.classList.toggle('on', x === b); });
      });
      function sellingPlan() {
        if (!subscribed) return null;
        return bar.getAttribute('data-sp-' + freq) || null;
      }

      bar.querySelectorAll('[data-ba-open-cart]').forEach(function (b) { b.addEventListener('click', openCart); });
      var cta = bar.querySelector('[data-ba-add-cta]');
      if (cta) cta.addEventListener('click', function () {
        if (bar.__count > 0) { openCart(); return; }
        if (!heroVariant) { openCart(); return; }
        var item = { id: heroVariant, quantity: 1 };
        var sp = sellingPlan(); if (sp) item.selling_plan = sp;
        window.baAddToCart([item], { noOpen: true, toastMessage: 'Added to cart' });
      });
      var clearBtn = bar.querySelector('[data-ba-clear]');
      if (clearBtn) clearBtn.addEventListener('click', function () { clearCart(); });

      bar.__render = function (cart) {
        var count = cart ? cart.item_count : 0;
        bar.__count = count;
        var has = count > 0;
        var badge = bar.querySelector('[data-ba-count]');
        if (badge) { badge.textContent = count; badge.hidden = !has; }
        var vialsEl = bar.querySelector('[data-ba-vials]');
        if (vialsEl) {
          var boxes = [];
          if (has && cart.items) cart.items.forEach(function (it, idx) {
            for (var q = 0; q < it.quantity; q++) boxes.push(PALETTE[(idx) % PALETTE.length]);
          });
          if (!has) boxes = [heroGlow];
          var shown = boxes.slice(0, 4);
          var extra = Math.max(0, (has ? count : 0) - shown.length);
          vialsEl.innerHTML = shown.map(function (g, i) {
            return '<span class="sb-vial" style="z-index:' + (10 - i) + ';background:linear-gradient(155deg,' + g + ',' + g + ');"></span>';
          }).join('') + (extra > 0 ? '<span class="sb-more">+' + extra + '</span>' : '');
        }
        var titleEl = bar.querySelector('[data-ba-title]');
        if (titleEl) titleEl.textContent = has ? (count + ' ' + (count === 1 ? 'box' : 'boxes') + ' in your cart') : titleEl.getAttribute('data-empty') || titleEl.textContent;
        var tierEl = bar.querySelector('[data-ba-tier]');
        if (tierEl) tierEl.innerHTML = count >= 4 ? '<b>' + t4 + '% off</b> unlocked 🎉'
          : count >= 2 ? '<b>4 boxes</b> ' + t4 + '% off'
          : '<b>2 boxes</b> ' + t2 + '% off';
        var rate = count >= 4 ? t4 / 100 : count >= 2 ? t2 / 100 : 0;
        var nowEl = bar.querySelector('[data-ba-now]');
        var wasEl = bar.querySelector('[data-ba-was]');
        var saveEl = bar.querySelector('[data-ba-save]');
        if (has && cart) {
          var sub = cart.total_price;
          var est = Math.round(sub * (1 - rate));
          if (nowEl) nowEl.textContent = money(est, symbol);
          if (wasEl) { wasEl.hidden = rate === 0; wasEl.textContent = money(sub, symbol); }
          if (saveEl) saveEl.textContent = rate > 0 ? 'YOU SAVE ' + Math.round(rate * 100) + '%' : 'SUB & SAVE';
        }
        var ctaEl = bar.querySelector('[data-ba-add-cta]');
        if (ctaEl) ctaEl.innerHTML = (has ? 'View cart' : 'Add to cart') + ' <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
        var clr = bar.querySelector('[data-ba-clear]'); if (clr) clr.hidden = !has;
        var metaEl = bar.querySelector('[data-ba-metaline]');
        if (metaEl && has) {
          var toNext = count < 2 ? 2 - count : count < 4 ? 4 - count : 0;
          var nextPct = count < 2 ? t2 : t4;
          metaEl.textContent = rate > 0 ? Math.round(rate * 100) + '% off applied' : (toNext ? 'Add ' + toNext + ' more box' + (toNext > 1 ? 'es' : '') + ' for ' + nextPct + '% off' : 'Free same-day delivery');
        }
      };
      if (bar.querySelector('[data-ba-title]')) bar.querySelector('[data-ba-title]').setAttribute('data-empty', bar.querySelector('[data-ba-title]').textContent);
      refreshCart();
    });
  }

  /* ---------- cart sync ---------- */
  function refreshCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ba-stickybar]').forEach(function (bar) { if (bar.__render) bar.__render(cart); });
        var count = cart ? cart.item_count : 0;
        document.querySelectorAll('.ba-bag-count, [data-ba-cart-count]').forEach(function (el) {
          el.textContent = count;
          if (!el.classList.contains('ba-bag-count')) {
            el.hidden = (count === 0);
            if (count === 0) el.style.display = 'none';
            else el.style.display = '';
          }
        });
        return cart;
      }).catch(function () {});
  }
  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  function clearCart() {
    fetch((window.routes && window.routes.cart_clear_url ? window.routes.cart_clear_url : '/cart/clear') + '.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () { refreshCart(); if (window.baToast) window.baToast('Cart cleared'); document.dispatchEvent(new CustomEvent('ba:cart:added', {})); });
  }

  /* ---------- toast ---------- */
  window.baToast = function (msg) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>' + msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2400);
  };

  /* ---------- add to cart — bioactive-aware, toast-first ---------- */
  window.baAddToCart = function (items, opts) {
    opts = opts || {};
    var bacHost = document.querySelector('[data-bac-drawer-host]');
    var sections = bacHost ? ['bioactive-cart-drawer'] : ['cart-icon-bubble', 'cart-drawer'];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function (data) {
        if (opts.toastMessage && window.baToast) window.baToast(opts.toastMessage);
        if (data.sections) {
          if (typeof window.__bacApplySections === 'function') {
            window.__bacApplySections(data.sections);
          } else {
            Object.keys(data.sections).forEach(function (key) {
              var html = data.sections[key];
              var sel = key === 'cart-icon-bubble' ? '#cart-icon-bubble' : (key === 'cart-drawer' ? 'cart-drawer' : null);
              if (!sel) return;
              var target = document.querySelector(sel);
              if (target && html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var fresh = doc.querySelector(sel);
                if (fresh) target.innerHTML = fresh.innerHTML;
              }
            });
          }
        }
        if (!opts.noOpen) {
          if (typeof window.__bacOpenDrawer === 'function') window.__bacOpenDrawer();
          else {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }
        }
        document.dispatchEvent(new CustomEvent('ba:cart:added', { detail: data }));
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (cart) {
            document.querySelectorAll('[data-cart-ct], .ba-bag-count, [data-bac-headcount-bubble]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          }
          if (opts.onDone) opts.onDone(cart);
          return cart;
        });
      })
      .catch(function (err) {
        var msg = (err && err.description) ? err.description : 'Could not add — try again';
        if (window.baToast) window.baToast(msg);
        if (opts.onError) opts.onError(err);
        console.error('[ba] add to cart failed', err);
      });
  };

  /* global add buttons (product cards, explorer) */
  function initAddButtons(root) {
    (root || document).querySelectorAll('[data-ba-add][data-variant-id]:not([data-ba-bound])').forEach(function (btn) {
      btn.setAttribute('data-ba-bound', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute('data-variant-id'); if (!id) return;
        window.baAddToCart([{ id: id, quantity: 1 }], { noOpen: true, toastMessage: (btn.getAttribute('data-name') || 'Item') + ' added' })
          .then(function () {
            document.dispatchEvent(new CustomEvent('ba:cart:open'));
          });
        btn.classList.add('added');
        setTimeout(function () { btn.classList.remove('added'); }, 1300);
      });
    });
  }

  /* ---------- Quiz modal ---------- */
  function initQuiz(root) {
    (root || document).querySelectorAll('[data-ba-quiz-config]:not([data-ba-bound])').forEach(function (cfgEl) {
      cfgEl.setAttribute('data-ba-bound', '1');
      var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      var wrap = cfgEl.parentNode.querySelector('[data-ba-quiz]');
      if (!wrap) return;
      var stage = wrap.querySelector('[data-ba-quiz-stage]');
      var prog = wrap.querySelector('[data-ba-quiz-prog]');
      var step = 0, answers = {};

      var AGE_NOTES = {
        a: 'In your 20s you\u2019re starting ahead \u2014 most people notice the first changes within 2\u20134 weeks.',
        b: 'For 30\u201344: the first changes typically show in 2\u20134 weeks, with full results building by week 8.',
        c: 'For 45\u201359: give it the full course \u2014 visible results typically build across weeks 8\u201312.',
        d: 'For 60+: consistency matters most \u2014 expect steady, compounding gains across 8\u201312 weeks.'
      };
      var CONS_NOTES = {
        daily: 'Daily ritual? The Duo Set keeps you covered for a while \u2014 and saves 20%.',
        most: 'Most days is plenty \u2014 the Duo Set (20% off) keeps you covered for a while.',
        off: 'Routine on and off? Start with the Single Box \u2014 upgrade once the habit sticks.'
      };

      function close() { wrap.classList.remove('show'); setTimeout(function () { wrap.hidden = true; }, 300); }
      function open(preset) {
        wrap.hidden = false; void wrap.offsetWidth; wrap.classList.add('show');
        step = preset ? 1 : 0; answers = preset ? { goal: preset } : {}; render();
      }
      function progress() {
        var total = cfg.steps.length;
        prog.innerHTML = '';
        for (var i = 0; i < total; i++) { var s = document.createElement('i'); if (i < (step >= total ? total : step + 1)) s.className = 'on'; prog.appendChild(s); }
      }
      function render() {
        progress();
        if (step < cfg.steps.length) {
          var q = cfg.steps[step];
          stage.innerHTML = '<div class="quiz-main"><h3>' + esc(q.q) + '</h3><div class="quiz-opts">' +
            q.opts.map(function (o) { return '<button class="quiz-opt" data-v="' + esc(o.v) + '">' + (o.e ? '<span class="qemoji">' + o.e + '</span> ' : '') + esc(o.t) + '</button>'; }).join('') +
            '</div></div>';
          stage.querySelectorAll('.quiz-opt').forEach(function (b) {
            b.addEventListener('click', function () { answers[q.key] = b.getAttribute('data-v'); step++; render(); });
          });
        } else {
          var goal = answers[cfg.steps[0] && cfg.steps[0].key] || (cfg.results[0] && cfg.results[0].match);
          var rec = cfg.results.filter(function (r) { return r.match === goal; })[0] || cfg.results[0];
          if (!rec) { stage.innerHTML = '<div class="quiz-result"><h3>Thanks!</h3></div>'; return; }
          var ageNote = AGE_NOTES[answers.age] || '';
          var consNote = CONS_NOTES[answers.consistency] || '';
          var noteHtml = (ageNote || consNote)
            ? '<div class="qnotes" style="margin:14px auto 0;max-width:340px;background:rgba(255,255,255,.75);border:1px solid rgba(0,0,0,.08);border-radius:12px;padding:11px 14px;text-align:left;font-size:12.5px;line-height:1.55;">' +
              (ageNote ? '<div>' + ageNote + '</div>' : '') +
              (consNote ? '<div style="margin-top:6px;">' + consNote + '</div>' : '') +
              '</div>'
            : '';
          var pairHtml = (rec.pair && rec.pair.name)
            ? '<div class="qpair" data-ba-quiz-pair role="button" tabindex="0" style="display:flex;align-items:center;gap:12px;margin:12px auto 0;max-width:340px;background:rgba(255,255,255,.9);border:1.5px dashed #2f8163;border-radius:12px;padding:11px 14px;text-align:left;cursor:pointer;">' +
              '<span style="width:22px;height:50px;border-radius:99px;flex-shrink:0;background:linear-gradient(160deg,' + esc(rec.pair.color || '#5b9b93') + ',' + esc(rec.pair.color || '#5b9b93') + ');"></span>' +
              '<span style="flex:1;min-width:0;"><span style="display:block;font-size:12.5px;font-weight:800;">Pairs well with ' + esc(rec.pair.name) + '</span>' +
              '<span style="display:block;font-size:11.5px;line-height:1.5;opacity:.8;">' + esc(rec.pair.desc || '') + ' <b style="color:#2f8163;">Also 20% off unlocks at 2 boxes.</b></span></span>' +
              '<span class="qpair-cta" style="font-size:12px;font-weight:800;color:#2f8163;white-space:nowrap;">+ Add both</span></div>'
            : '';
          stage.innerHTML = '<div class="quiz-result">' +
            '<span class="rvial" style="background:linear-gradient(155deg,' + rec.color + ',' + rec.color + ');"></span>' +
            '<span class="eyebrow no-dash" style="justify-content:center;">' + esc(cfg.resultEyebrow || 'We recommend') + '</span>' +
            '<h3>' + esc(rec.name || '') + '</h3><div class="rsub">' + esc(rec.desc || '') + '</div>' +
            (rec.ings ? '<div class="ring-list">' + esc(rec.ings) + '</div>' : '') +
            noteHtml + pairHtml +
            '<button class="btn btn-primary btn-block" data-ba-quiz-add style="margin-top:14px;">Start ' + esc(rec.name || '') + ' · ' + esc(rec.priceText || '') + '</button>' +
            '<button class="btn btn-light btn-sm btn-block" data-ba-quiz-retake style="margin-top:10px;">Retake quiz</button>' +
            '</div>';
          function bundleUrl(vids) {
            if (!rec.url) return null;
            var ids = vids.filter(function (v) { return v && v !== 0 && v !== '0'; }).join(',');
            return rec.url + (ids ? (rec.url.indexOf('?') > -1 ? '&' : '?') + 'preload=' + ids : '');
          }
          var add = stage.querySelector('[data-ba-quiz-add]');
          if (add) add.addEventListener('click', function () {
            if (rec.variantId) window.baAddToCart([{ id: rec.variantId, quantity: 1 }], { toastMessage: (rec.name || 'Item') + ' added' });
            else if (rec.url) { window.location.href = bundleUrl([rec.mainVid]) || rec.url; return; }
            close();
          });
          var pairEl = stage.querySelector('[data-ba-quiz-pair]');
          if (pairEl) pairEl.addEventListener('click', function () {
            var mainId = rec.variantId || rec.mainVid;
            var toBundle = bundleUrl([mainId, rec.pair && rec.pair.vid]);
            if (toBundle) { window.location.href = toBundle; return; }
            var items = [];
            if (mainId) items.push({ id: mainId, quantity: 1 });
            if (rec.pair && rec.pair.vid) items.push({ id: rec.pair.vid, quantity: 1 });
            var cta = pairEl.querySelector('.qpair-cta');
            if (items.length) {
              window.baAddToCart(items, { noOpen: true, toastMessage: items.length > 1 ? ((rec.name || 'Item') + ' + ' + (rec.pair.name || 'pair') + ' added — 20% off unlocked') : (((rec.pair && rec.pair.name) || rec.name || 'Item') + ' added') });
              pairEl.style.borderStyle = 'solid';
              if (cta) cta.textContent = items.length > 1 ? '✓ Both added' : '✓ Added';
            } else if (rec.pair && rec.pair.url) {
              window.location.href = rec.pair.url;
            }
          });
          var retake = stage.querySelector('[data-ba-quiz-retake]');
          if (retake) retake.addEventListener('click', function () { step = 0; answers = {}; render(); });
        }
      }
      wrap.addEventListener('click', function (e) { if (e.target === wrap || e.target.closest('[data-ba-quiz-close]')) close(); });
      wrap.__open = open;
      if (!window.baOpenQuiz) window.baOpenQuiz = function (preset) { open(preset); };
    });
    (root || document).querySelectorAll('[data-ba-quiz-open], a[href="#quiz"], a[href="#ba-quiz"]').forEach(function (btn) {
      if (btn.getAttribute('data-ba-bound-trig')) return;
      btn.setAttribute('data-ba-bound-trig', '1');
      btn.addEventListener('click', function (e) { e.preventDefault(); if (window.baOpenQuiz) window.baOpenQuiz(btn.getAttribute('data-goal') || null); });
    });
  }

  /* ---------- swipe-hint carousels ---------- */
  function initSwipe(root) {
    (root || document).querySelectorAll('[data-ba-swipe]:not([data-ba-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-ba-bound', '1');
      var track = wrap.querySelector('[data-ba-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-ba-prev]');
      var next = wrap.querySelector('[data-ba-next]');
      var hint = wrap.querySelector('[data-ba-hint]');
      var cardSel = wrap.getAttribute('data-ba-card') || '';
      function update() {
        var atStart = track.scrollLeft <= 8;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        if (prev) prev.classList.toggle('is-hidden', atStart);
        if (next) next.classList.toggle('is-hidden', atEnd);
        if (hint) hint.classList.toggle('is-hidden', atEnd);
      }
      function nudge(dir) {
        var card = cardSel ? track.querySelector(cardSel) : track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16') || 16;
        var pitch = card ? card.offsetWidth + gap : track.clientWidth * 0.85;
        var steps = Math.max(1, Math.floor((track.clientWidth * 0.85) / pitch));
        var max = track.scrollWidth - track.clientWidth;
        var from = track.scrollLeft;
        var to = Math.max(0, Math.min(max, from + dir * steps * pitch));
        var dur = 420, t0 = performance.now();
        var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
        function tick(now) {
          var k = Math.min(1, (now - t0) / dur);
          track.scrollLeft = from + (to - from) * ease(k);
          if (k < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initHeaderCart(root) {
    (root || document).querySelectorAll('.ba-actions a[href*="/cart"], .pdp-bag, .pdp-bag-btn').forEach(function (btn) {
      if (btn.getAttribute('data-ba-bound-cart')) return;
      btn.setAttribute('data-ba-bound-cart', '1');
      btn.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          drawer.open();
        }
      });
    });
  }

  function initAll(root) {
    initReveals(root); initMarquees(root); initFaq(root); initDiscover(root);
    initBuilder(root); initStickyBars(root); initAddButtons(root); initQuiz(root);
    initSwipe(root); initHeaderCart(root); initBundlePreload();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  if (document.readyState !== 'loading') initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('ba:cart:added', function () { refreshCart(); });
  if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(); }); } catch (e) {}
  }

  window.__baInit = initAll;
})();
